import { ALL_USER_ROLES, isProviderRole } from '../data.types.js';
const TENANT_ADMIN_ACTIONS = new Set([
    'wafer:read', 'wafer:create', 'wafer:update', 'wafer:delete',
    'container:read', 'container:create', 'container:update', 'container:delete',
    'user:read', 'user:list', 'user:create', 'user:update', 'user:delete', 'user:change_role',
    'group:read', 'group:create', 'group:update', 'group:delete',
    'contact:read', 'contact:create', 'contact:update', 'contact:delete',
    'customer:read', 'customer:create', 'customer:update', 'customer:delete',
    'billing:read', 'billing:manage',
    'scan_template:read', 'scan_template:write',
    'job:run', 'job:abort_admin',
]);
const TENANT_LEAD_ACTIONS = new Set([
    'wafer:read', 'wafer:create', 'wafer:update',
    'container:read', 'container:create', 'container:update',
    'user:read', 'user:list', 'user:create', 'user:update', 'user:delete',
    'group:read',
    'contact:read', 'contact:create', 'contact:update', 'contact:delete',
    'customer:read', 'customer:create', 'customer:update', 'customer:delete',
    'scan_template:read', 'scan_template:write',
    'job:run',
]);
const TENANT_ENGINEER_ACTIONS = new Set([
    'wafer:read',
    'container:read',
    'user:read',
    'group:read',
    'customer:read',
    'scan_template:read',
    'job:run',
]);
const PROVIDER_ADMIN_ACTIONS = new Set([
    'provider:tenant_read', 'provider:subscription_read', 'provider:support_viewer',
    'billing:manage',
]);
const PROVIDER_ENGINEER_ACTIONS = new Set([
    'provider:tenant_read', 'provider:subscription_read',
]);
const PROVIDER_DEPLOYMENT_ACTIONS = new Set([
    'provider:tenant_read',
]);
const PROVIDER_SUPPORT_ACTIONS = new Set([
    'provider:tenant_read', 'provider:subscription_read', 'provider:support_viewer',
]);
const ROLE_ACTIONS = {
    [ALL_USER_ROLES.tenant_admin]: TENANT_ADMIN_ACTIONS,
    [ALL_USER_ROLES.tenant_lead]: TENANT_LEAD_ACTIONS,
    [ALL_USER_ROLES.tenant_engineer]: TENANT_ENGINEER_ACTIONS,
    [ALL_USER_ROLES.provider_admin]: PROVIDER_ADMIN_ACTIONS,
    [ALL_USER_ROLES.provider_engineer]: PROVIDER_ENGINEER_ACTIONS,
    [ALL_USER_ROLES.provider_deployment_engineer]: PROVIDER_DEPLOYMENT_ACTIONS,
    [ALL_USER_ROLES.provider_support]: PROVIDER_SUPPORT_ACTIONS,
    [ALL_USER_ROLES.unknown]: new Set(),
};
const NAV_TIERS_BY_ROLE = {
    [ALL_USER_ROLES.provider_admin]: ['Admin'],
    [ALL_USER_ROLES.provider_engineer]: ['Admin', 'Lead', 'Engineer'],
    [ALL_USER_ROLES.provider_support]: ['Support'],
    [ALL_USER_ROLES.provider_deployment_engineer]: ['Deployment'],
    [ALL_USER_ROLES.tenant_admin]: ['Admin'],
    [ALL_USER_ROLES.tenant_lead]: ['Lead'],
    [ALL_USER_ROLES.tenant_engineer]: ['Engineer'],
    [ALL_USER_ROLES.unknown]: [],
};
export function can(role, action) {
    if (!role || !(role in ROLE_ACTIONS)) {
        return false;
    }
    return ROLE_ACTIONS[role].has(action);
}
/** Legacy helper — groups are optional tags; inventory is not filtered by scope mode. */
export function getScopeMode(role) {
    if (!role)
        return 'assigned_groups';
    if (isProviderRole(role))
        return 'platform';
    if (role === ALL_USER_ROLES.tenant_admin)
        return 'all_groups';
    return 'assigned_groups';
}
export function getNavTiersForRole(role) {
    if (!role || !(role in NAV_TIERS_BY_ROLE)) {
        return [];
    }
    return NAV_TIERS_BY_ROLE[role];
}
export function canManageTenantUsers(role) {
    return can(role, 'user:create') || can(role, 'user:update');
}
export function canEditTargetTenantUser(actorRole, targetRole) {
    if (actorRole === ALL_USER_ROLES.tenant_admin) {
        return true;
    }
    if (actorRole === ALL_USER_ROLES.tenant_lead) {
        return targetRole === ALL_USER_ROLES.tenant_engineer;
    }
    return false;
}
export function intersectsGroupIds(a, b) {
    if (a.length === 0 || b.length === 0)
        return false;
    const setB = new Set(b);
    return a.some((id) => setB.has(id));
}
//# sourceMappingURL=access-policy.js.map